module.exports = __webpack_public_path__ + "assets/img/infoItem01.f44076d0.png";